<template lang='pug'>
  transition
    bf-flex.centered.bf-notice(v-show='message')
      bf-flex.centered.wrapper
        span.message {{ $t(message) }}
        span.close(@click='$emit("close")')
          close-icon
</template>

<script>
  import { auth } from '@/main'

  export default {
    name: 'bf-notice.component',

    props: {
      message: String
    },
  }
</script>

<style scoped lang='stylus'>
  .bf-notice
    position fixed
    top 0
    left 0
    width 100vw
    height 100vh
    background rgba( 0 0 0 .5 )
    z-index 8
    text-align center
    .wrapper
      padding 16px 32px
      margin 32px
      color var(--clr-notice)
      background var(--bg-notice)
      position relative
    .message
      padding 0 28px
    .close
      position absolute
      right 12px
      font-size 1.2em
      background rgba( 255 255 255 .25 )
      padding 4px 8px
    // @media(min-width: 1080px)
      // left var(--width-nav)
      // width calc( 100vw - var(--width-nav) )
</style>
